import { DefaultTheme } from 'styled-components';
import * as defaultDesign from '../tokens/designs/default';
import * as dueliDesign from '../tokens/designs/dueli';

export type DesignId = 'default' | 'dueli';
export type Mode = 'light' | 'dark';

const designs = { default: defaultDesign, dueli: dueliDesign };

function buildTheme(designId: DesignId, mode: Mode): DefaultTheme {
	const design = designs[designId];
	const c = design.primitiveColors;
	const semantic = mode === 'light' ? design.semanticLight : design.semanticDark;
	let components = mode === 'light'
		? design.createComponentTokensLight(semantic)
		: design.createComponentTokensDark(semantic);
	// Стили компонентов, общие для light/dark (radius и т.д.) — один раз на дизайн
	const componentStyles = (design as { componentStyles?: Partial<Record<string, Record<string, string>>> }).componentStyles;
	if (componentStyles) {
		components = { ...components } as typeof components;
		for (const [key, overrides] of Object.entries(componentStyles)) {
			if (overrides && key in components) {
				const current = (components as unknown as Record<string, object>)[key];
				(components as unknown as Record<string, object>)[key] = { ...current, ...overrides };
			}
		}
	}
	return {
		title: mode,
		designId,
		semantic,
		components,
		brand: {
			primary: c.primary[500],
			primaryLight: c.primary[400],
			primaryTransparent: c.alpha.primary20,
			secondary: c.secondary[500],
			secondaryDark: c.secondary[600],
			secondaryTransparent: c.alpha.secondary20,
			accent: c.accent[500],
			accentMedium: c.accent[550],
			accentDark: c.accent[600],
			accentTransparent: c.alpha.accent20,
			error: c.error[500],
			redTransparent: c.alpha.error20,
		},
		testBackground: c.testBg,
		scaleGradient: c.scale,
		fontSnippets: design.fontSnippets,
		primitives: {
			radius: design.primitiveRadius,
			spacing: design.primitiveSpacing,
			shadows: design.primitiveShadows,
			typography: design.primitiveTypography,
			colors: design.primitiveColors,
		},
	} as DefaultTheme;
}

const cache: Partial<Record<`${DesignId}-${Mode}`, DefaultTheme>> = {};

export function getTheme(designId: DesignId, mode: Mode): DefaultTheme {
	const key = `${designId}-${mode}` as const;
	const cached = cache[key];
	if (cached) return cached;
	const theme = buildTheme(designId, mode);
	cache[key] = theme;
	return theme;
}
